// Invalidation notices only: project/experiment contents never enter browser storage.
export const PROJECT_CHANGE_EVENT = 'lab-op-projects-changed';
export const PROJECT_CHANGE_STORAGE = 'lab-op.project-change.v1';
let version = 0;
let connected = false;

function connect() {
  if (connected || typeof window === 'undefined') return;
  connected = true;
  window.addEventListener(PROJECT_CHANGE_EVENT, event => {
    version += 1;
    if (event.detail?.remote) return;
    try {
      window.localStorage.setItem(PROJECT_CHANGE_STORAGE, `${Date.now()}:${Math.random().toString(36).slice(2)}`);
    } catch { /* Same-tab refresh still works when storage is unavailable. */ }
  });
  window.addEventListener('storage', event => {
    if (event.key === PROJECT_CHANGE_STORAGE && event.newValue) {
      window.dispatchEvent(new CustomEvent(PROJECT_CHANGE_EVENT, { detail: { remote: true } }));
    }
  });
}

export function projectChangeVersion() { connect(); return version; }

export function notifyProjectChange() {
  connect();
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(PROJECT_CHANGE_EVENT));
}

export function subscribeProjectChanges(listener) {
  connect();
  window.addEventListener(PROJECT_CHANGE_EVENT, listener);
  return () => window.removeEventListener(PROJECT_CHANGE_EVENT, listener);
}

export function isProjectMutation(url, method = 'get') {
  if (!['post', 'put', 'patch', 'delete'].includes(String(method).toLowerCase()) || !url) return false;
  let path;
  try { path = new URL(url, 'https://project-change.invalid').pathname; }
  catch { return false; }
  return /^(?:\/api)?\/(?:research-planner\/projects|projects|protocols|protocol-runs|experiments|approvals|timeline-planner\/(?:projects|step-defs)|project-workflow\/(?:items|plan\/tasks|plan\/experiments))(?:\/|$)/.test(path);
}
